module.exports = __webpack_public_path__ + "img/phone-siemens.8f10b76b.png";